import valueSeriesTableTemplate from './reactValueSeriesTable.html';
import {VALUES, VALUE_SERIES} from '../../../services/arsweb/RoutingPaths';
import { reactValueSeriesCols, defaultSortModel } from './valueSeriesColDefs';
import { VALUESERIES_TITLE } from '../../../services/arsweb/TableTitles';
import {ReactTableController} from "../reactTableController";
import { valueSeriesOptions} from "../../../views/administration/userReports/UserReportDetailDialogController";
import {BackendService} from "../../../services/BackendService";
import moment from "moment";

/** @ngInject */
export function reactValueSeriesTable() {
    return {
        restrict: 'E',
        scope: {
            parentController: '=',
            tableId: '@',
            filter: '=',
            tabName: '='
        },
        templateUrl: valueSeriesTableTemplate,
        controller: ReactValueSeriesTableController,
        controllerAs: 'valueSeriesTableController'
    };
}

/** @ngInject */
export class ReactValueSeriesTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, null, new BackendService(userService, VALUE_SERIES), VALUES,
            VALUESERIES_TITLE, 'valueSeriesTableParams' + $scope.tabName, 'lk', false, valueSeriesOptions, defaultSortModel);

        $scope.$on('consolidationCurrency.change', () => this.resetGridSelection());
        $scope.$on('dateSnapshot.change', () => this.resetGridSelection());

        this.backendService.service.config.params.dateFilter = this.$scope.parentController.dateFilter;
        this.dataFilter([]);
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));
    }

    initGrid(userService) {
        userService.promise.then(()=> {
            // react value series columns
            this.colDefs = reactValueSeriesCols(this.translate, userService, this.$scope.tabName);
            this.initCols();
            // react gridParameters for account table
            const valueSeriesGridParams = {
                columnDefs: this.colDefs,
                columnMapping: {'currencyCode' : 'currency', "countryName": "country"},
                url: this.backendService.service.getServiceUrl(VALUE_SERIES + VALUES),
                requestParams: this.backendService.service.config.params
            };
            this.defaultReactGridParams.gridOptions.getRowId = (params) => {
                // if leaf level, we have ID
                return params.data.key;
            }
            this.reactGridParams = {...this.defaultReactGridParams, ...valueSeriesGridParams};
        });
    }

    checkMaxAccountsForReport() { // check select all report max individual acc selection for valueseries
        if (this.isAllSelected) {
            const dateRange = this.ftsMainDependencies.$rootScope.dateFilter.dateRange;
            const diffDays = moment(dateRange.upperBound).diff(moment(dateRange.lowerBound),'days',true);
            const totalAccounts = this.total/(Math.round(diffDays) + 1);
            if (totalAccounts >= this.maxAccounts) {
                this.infoPop(this.translate.instant('ACCOUNT_REPORT_LIMIT',
                    {rowsLimit: this.maxAccounts, rowsCounter: totalAccounts}));
                this.overLimit = true;
                return false;
            }
        }
        this.overLimit = false;
        return true;
    }
}
